<template>
  <div class="stars">
    <eg-icon
      v-for="index in count"
      :key="index"
      icon="star-filled"
      size="extra-small"
    />
  </div>
</template>

<script>
export default {
  name: "BannerStars",
  props: {
    count: {
      type: Number,
      default: 5,
    },
  },
};
</script>

<style scoped lang="scss">
.stars {
  color: var(--colors-orange-500);
  line-height: 10px;
}
</style>
